export const institucionalLinks = [
    { href: '/institucional/quem-somos', label: 'Quem somos?' },
    { href: '/institucional/termos-de-uso', label: 'Termos de uso' },
    { href: '/institucional/politica-de-privacidade', label: 'Política de privacidade' },
    { href: '/jobs', label: 'Trabalhe conosco' },
    { href: '/institucional/imprensa', label: 'Imprensa'},
    { href: '/institucional/contato', label: 'Contato' },
]